// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'b0654da29277abb572e06e212da009b576c0b38b';
export const BUILD_NUMBER = '190';
export const BUILD_TIMESTAMP = '2026-07-09T03:20:28.732Z';
